function t() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(r) {
    var x = Math.random() * 16 | 0, n = r == "x" ? x : x & 3 | 8;
    return n.toString(16);
  });
}
export {
  t as uuid
};
